module.exports = __webpack_public_path__ + "static/media/service-provider-icon.49047a89.svg";